<app-card-table
    #personInsuranceTable
    [tableTitle]="'database.persons.createPage.insurance'"
    [columns]="columns"
    [items]="insurances"
    [gridData]="insurances?.length ? undefined : store.data.getPersonInsurances()"
    [translatePrefix]="insurancePrefix"
    [refreshCallback]="store.api.getPersonInsurances"
    [additionalFilter]="personFilter()"
    [defaultSorters]="[{ column: 'insuredFrom', direction: 'DESC' }]"
    (deleteCallbackWithEvent)="deletePersonInsurance($event)"
    (createCallback)="editInsurance()"
    (detailCallback)="editInsurance($event)"
    [showDetail]="!!personId() && canEdit()"
    [hideCheckboxes]="true"
    [showDelete]="canEdit()"
    [showCreate]="canEdit()"
>
    <ng-template pTemplate="insuranceType" let-data="data">
        {{ 'enum.insuranceType.' + data | translate }}
    </ng-template>
</app-card-table>
